import { BasePutRequest } from './core/basePutRequest';
import * as t from 'io-ts';
import { Authentication } from './core/baseRequest';

export class AcknowledgeLoyaltyTermsAndConditionsRequest extends BasePutRequest<undefined> {
    constructor() {
        super(`loyalty-terms-and-conditions/acknowledge`, {}, {}, t.undefined, Authentication.Login);
    }
}
